<select class="input minimal" (change)="addRateSetFilter($event)" [value]="SelectedRateSet">
  <option value="" style="color:gray">No Rate Set Filter</option>
  @for (i of RateSets; track i) {
    <option [selected]="RateSetSelected(i)" [value]="i.Id.toString()">{{i.Name}}
    </option>
  }
</select>
